import { render, staticRenderFns } from "./livingDing_list.vue?vue&type=template&id=7b64f142&scoped=true&"
import script from "./livingDing_list.vue?vue&type=script&lang=js&"
export * from "./livingDing_list.vue?vue&type=script&lang=js&"
import style0 from "./livingDing_list.vue?vue&type=style&index=0&id=7b64f142&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b64f142",
  null
  
)

export default component.exports